/**
 * Composable for selecting which PDF viewer implementation to use.
 *
 * Driven by the PDF_VIEW_DRIVER env var:
 *   - 'adobe'  → Adobe PDF Embed API (requires ADOBE_PDF_EMBED_CLIENT_ID).
 *                If Adobe fails to load or render, consumers fall back to the
 *                native iframe via the AdobePdfViewer's `failed` event.
 *   - 'browser' (default, also when unset) → native browser PDF viewer in an
 *                iframe. No third-party dependencies.
 */
export const usePdfViewer = () => {
    const config = useRuntimeConfig();

    const adobeEnabled = computed(() => config.public.pdfViewDriver === 'adobe');

    return {
        adobeEnabled
    };
};
